import React, { Component } from 'react'
import { Form, Input, Button, Alert } from 'antd'
import { api } from '../../../../services'

class ConfirmForm extends Component {
  state = {

    error: {
      status: false,
      message: null,
      confirmDirty: false
    },
    success: false,
    data: null
  }

  componentDidMount () {
    const { token } = this.props

    api.user.identifyUserByToken(token)
      .then((response) => {
        this.setState({
          data: response.data.result
        })
      })
      .catch(error => {
        this.setError({
          status: true,
          message: error.response.data.error.message
        })
      })
  }

  setError = (payload) => {
    this.setState({
      error: payload
    })
  }

  handleSubmit = (e) => {
    const { form, token } = this.props

    e.preventDefault()

    form.validateFields((err, values) => {
      if (!err) {
        this.setError({
          status: false,
          message: null
        })
        api.user.confirmUser(token, values.password)
          .then((response) => {
            this.setState({
              success: true,
              data: null
            })
          })
          .catch((response) => {
            this.setError({
              status: true,
              message: response.data.error.message
            })
          })
      }
    })
  }

  handleReset = () => {
    const { form: { resetFields } } = this.props
    resetFields()
  }

  handleConfirmBlur = (e) => {
    const { confirmDirty } = this.state
    const value = e.target.value
    this.setState({ confirmDirty: confirmDirty || !!value })
  }

  validateToNextPassword = (rule, value, callback) => {
    const { confirmDirty } = this.state
    const { form: { validateFields } } = this.props

    if (value && confirmDirty) {
      validateFields(['repeatPassword'], { force: true })
    }
    callback()
  }

  compareToFirstPassword = (rule, value, callback) => {
    const { form: { getFieldValue } } = this.props

    if (value && value !== getFieldValue('password')) {
      const msg = 'Passwords are inconsistent'
      callback(msg)
    } else {
      callback()
    }
  }

  render () {
    const { error, success, data } = this.state
    const { form: { getFieldDecorator } } = this.props

    return (
      <Form onSubmit={this.handleSubmit} className='form form_center'>

        <h3 style={{ marginBottom: '0px' }}>Restore Password</h3>
        <p style={{ fontSize: '18px', textAlign: 'center', marginBottom: '20px' }}>Setup your new password</p>

        { error.status ? <div className='form__error'>{ error.message }</div> : null }
        { success ? <Alert message='Your password has been reset successfully.' type='success' /> : null }

        { data === null
          ? <div />
          : <div>

            <Form.Item>
              {getFieldDecorator('password', {
                rules: [{ required: true,
                  message: 'Please input your password',
                  max: 320
                }, {
                  validator: this.validateToNextPassword
                }]
              })(
                <Input type='password' name='password' placeholder='Password' />
              )}
            </Form.Item>

            <Form.Item>
              {getFieldDecorator('repeatPassword', {
                rules: [{
                  required: true, message: 'Please repeat your password'
                }, {
                  validator: this.compareToFirstPassword
                }]
              })(
                <Input type='password' onBlur={this.handleConfirmBlur} placeholder='Repeat Password' />
              )}
            </Form.Item>

            <Form.Item>
              <Button type='indigo' htmlType='submit' className='login__button'>Save password</Button>
            </Form.Item>
          </div> }

      </Form>
    )
  }
}

export default Form.create()(ConfirmForm)



// WEBPACK FOOTER //
// ./src/views/ResetConfirm/components/ConfirmForm/ConfirmForm.jsx